import { useTranslation } from 'react-i18next';
import RegionItem from '@pages/sales-network/shared/RegionItem';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { useGetPartnersByCountryQuery } from '@api/baseApi';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



interface RegionsListProps {
	selectedRegion: string,
	country: AppLanguageCode,
}


const RegionsList = (props: RegionsListProps) => {
	const { selectedRegion, country } = props;
	const { t } = useTranslation('global');

	const { data, isLoading, isFetching, isError } = useGetPartnersByCountryQuery({ country });

	if (isError) return (
		<div className='regions-list'>
			<p className='error-message'>{t('loadingErrorMessage')}</p>
		</div>
	)

	if (isLoading || isFetching) return (
		<div className='regions-list'>
			<p className='loading-message'><LoadingSpinner /></p>
		</div>
	)

	return (
		<div className='regions-list'>

			{data && data.map(x =>
				<RegionItem
					region={x}
					selectedRegion={selectedRegion}
					key={`regions-list-${x.key}`} />)}
		
		</div>
	);
};

export default RegionsList;